import * as actionTypes from "../actions/actionTypes";

const initState = {
  becoming: false,
  amFeatured: false,
  error: null,
};

const initBecomeFeature = (state, action) => {
  return {
    ...state,
    becoming: action.becoming,
    amFeatured: false,
    error: null,
  };
};

const successBecomeFeature = (state, action) => {
  return {
    ...state,
    becoming: action.becoming,
    amFeatured: action.amFeatured,
  };
};

const failBecomeFeature = (state, action) => {
  return {
    ...state,
    becoming: action.becoming,
    error: action.error,
  };
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.INIT_BECOME_FEATURE_DEALER:
      return initBecomeFeature(state, action);
    case actionTypes.SUCCESS_BECOME_FEATURE_DEALER:
      return successBecomeFeature(state, action);
    case actionTypes.FAIL_BECOME_FEATURE_DEALER:
      return failBecomeFeature(state, action);
    default:
      return state;
  }
};

export default Reducer;
